import React, { useState } from 'react';
import { Nav } from 'react-bootstrap';
import { useSelector } from 'react-redux'

const SidebarAccount = ({ user }) => {
  const [activeKey, setActiveKey] = useState(location.pathname);

  const { registration_platform, role } = useSelector((state) => state.auth.user)
  const sso_google_linked_login = registration_platform;

  let profile_path = "/dashboard/account/personal-info";
  let security_path = "/dashboard/account/user-security";

  if (role === "manager") {
    profile_path = "/manager/dashboard/account/personal-info";
    security_path = "/manager/dashboard/account/user-security";
  }

  const securityTab = (
    <NavItem
      link={security_path}
      name="Security"
      icon={<SecurityIcon />}
    />
  )

  return (
    <div className="SidebarBilling SidebarAccount">
      <div className="sidebar-title-m" style={{marginBottom: '16px'}}>
        <span className="toggle-name">ACCOUNT SETTINGS</span>
      </div>
      <Nav as="ul" className="flex-column" activeKey={activeKey}>
        <NavItem link={profile_path} name="Profile" icon={<ProfileIcon />} />
        {sso_google_linked_login === 0 && securityTab}
      </Nav>
    </div>
  );
};

const NavItem = ({ link, name, icon }) => {
  return (
    <Nav.Item as="li">
      <Nav.Link href={link}>
        {icon}
        <span className="nav-name">{name}</span>
      </Nav.Link>
    </Nav.Item>
  );
};

// Define your SVG icon components
const ProfileIcon = () => (
  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="Icons">
      <path
        id="Vector"
        d="M12.5 12C11.4 12 10.4583 11.6083 9.675 10.825C8.89167 10.0417 8.5 9.1 8.5 8C8.5 6.9 8.89167 5.95833 9.675 5.175C10.4583 4.39167 11.4 4 12.5 4C13.6 4 14.5417 4.39167 15.325 5.175C16.1083 5.95833 16.5 6.9 16.5 8C16.5 9.1 16.1083 10.0417 15.325 10.825C14.5417 11.6083 13.6 12 12.5 12ZM4.5 20V17.2C4.5 16.6333 4.64583 16.1125 4.9375 15.6375C5.22917 15.1625 5.61667 14.8 6.1 14.55C7.13333 14.0333 8.18333 13.6458 9.25 13.3875C10.3167 13.1292 11.4 13 12.5 13C13.6 13 14.6833 13.1292 15.75 13.3875C16.8167 13.6458 17.8667 14.0333 18.9 14.55C19.3833 14.8 19.7708 15.1625 20.0625 15.6375C20.3542 16.1125 20.5 16.6333 20.5 17.2V20H4.5Z"
        fill="#9CA8BB"
      />
    </g>
  </svg>
);

const UserManagement = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="Icons" clipPath="url(#clip0_1448_2043)">
      <path
        id="Vector"
        d="M0 18V16.425C0 15.7083 0.366667 15.125 1.1 14.675C1.83333 14.225 2.8 14 4 14C4.21667 14 4.425 14.0042 4.625 14.0125C4.825 14.0208 5.01667 14.0417 5.2 14.075C4.96667 14.425 4.79167 14.7917 4.675 15.175C4.55833 15.5583 4.5 15.9583 4.5 16.375V18H0ZM6 18V16.375C6 15.8417 6.14583 15.3542 6.4375 14.9125C6.72917 14.4708 7.14167 14.0833 7.675 13.75C8.20833 13.4167 8.84583 13.1667 9.5875 13C10.3292 12.8333 11.1333 12.75 12 12.75C12.8833 12.75 13.6958 12.8333 14.4375 13C15.1792 13.1667 15.8167 13.4167 16.35 13.75C16.8833 14.0833 17.2917 14.4708 17.575 14.9125C17.8583 15.3542 18 15.8417 18 16.375V18H6ZM19.5 18V16.375C19.5 15.9417 19.4458 15.5333 19.3375 15.15C19.2292 14.7667 19.0667 14.4083 18.85 14.075C19.0333 14.0417 19.2208 14.0208 19.4125 14.0125C19.6042 14.0042 19.8 14 20 14C21.2 14 22.1667 14.2208 22.9 14.6625C23.6333 15.1042 24 15.6917 24 16.425V18H19.5ZM4 13C3.45 13 2.97917 12.8042 2.5875 12.4125C2.19583 12.0208 2 11.55 2 11C2 10.4333 2.19583 9.95833 2.5875 9.575C2.97917 9.19167 3.45 9 4 9C4.56667 9 5.04167 9.19167 5.425 9.575C5.80833 9.95833 6 10.4333 6 11C6 11.55 5.80833 12.0208 5.425 12.4125C5.04167 12.8042 4.56667 13 4 13ZM20 13C19.45 13 18.9792 12.8042 18.5875 12.4125C18.1958 12.0208 18 11.55 18 11C18 10.4333 18.1958 9.95833 18.5875 9.575C18.9792 9.19167 19.45 9 20 9C20.5667 9 21.0417 9.19167 21.425 9.575C21.8083 9.95833 22 10.4333 22 11C22 11.55 21.8083 12.0208 21.425 12.4125C21.0417 12.8042 20.5667 13 20 13ZM12 12C11.1667 12 10.4583 11.7083 9.875 11.125C9.29167 10.5417 9 9.83333 9 9C9 8.15 9.29167 7.4375 9.875 6.8625C10.4583 6.2875 11.1667 6 12 6C12.85 6 13.5625 6.2875 14.1375 6.8625C14.7125 7.4375 15 8.15 15 9C15 9.83333 14.7125 10.5417 14.1375 11.125C13.5625 11.7083 12.85 12 12 12Z"
        fill="#9CA8BB"
      />
    </g>
    <defs>
      <clipPath id="clip0_1448_2043">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const LinkedAccountsIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="Icons">
      <path
        id="Vector"
        d="M11 17H7C5.61667 17 4.4375 16.5125 3.4625 15.5375C2.4875 14.5625 2 13.3833 2 12C2 10.6167 2.4875 9.4375 3.4625 8.4625C4.4375 7.4875 5.61667 7 7 7H11V9H7C6.16667 9 5.45833 9.29167 4.875 9.875C4.29167 10.4583 4 11.1667 4 12C4 12.8333 4.29167 13.5417 4.875 14.125C5.45833 14.7083 6.16667 15 7 15H11V17ZM8 13V11H16V13H8ZM13 17V15H17C17.8333 15 18.5417 14.7083 19.125 14.125C19.7083 13.5417 20 12.8333 20 12C20 11.1667 19.7083 10.4583 19.125 9.875C18.5417 9.29167 17.8333 9 17 9H13V7H17C18.3833 7 19.5625 7.4875 20.5375 8.4625C21.5125 9.4375 22 10.6167 22 12C22 13.3833 21.5125 14.5625 20.5375 15.5375C19.5625 16.5125 18.3833 17 17 17H13Z"
        fill="#9CA8BB"
      />
    </g>
  </svg>
);

const SecurityIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="Icons">
      <path
        id="Vector"
        d="M10.95 15.55L16.6 9.9L15.175 8.475L10.95 12.7L8.85 10.6L7.425 12.025L10.95 15.55ZM12 22C9.68333 21.4167 7.77083 20.0875 6.2625 18.0125C4.75417 15.9375 4 13.6333 4 11.1V5L12 2L20 5V11.1C20 13.6333 19.2458 15.9375 17.7375 18.0125C16.2292 20.0875 14.3167 21.4167 12 22Z"
        fill="#9CA8BB"
      />
    </g>
  </svg>
);

const VerificationIcon = () => (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    style={{ fill: 'rgb(181, 182, 183)' }}
  >
    <path
      d="M20.8835 11.4501L19.3335 9.67512L19.5502 7.32512C19.5918 6.90845 19.3085 6.52512 18.9085 6.43345L16.6085 5.91679L15.4085 3.88345C15.1918 3.52512 14.7502 3.37512 14.3585 3.54179L12.2002 4.46679L10.0418 3.54179C9.6585 3.37512 9.2085 3.52512 9.00016 3.88345L7.79183 5.90845L5.50016 6.42512C5.09183 6.51679 4.8085 6.89179 4.85016 7.30845L5.06683 9.66679L3.5085 11.4501C3.2335 11.7668 3.2335 12.2335 3.5085 12.5501L5.06683 14.3251L4.85016 16.6835C4.8085 17.1001 5.09183 17.4835 5.49183 17.5751L7.79183 18.1001L8.99183 20.1251C9.2085 20.4835 9.6585 20.6335 10.0418 20.4668L12.2002 19.5251L14.3585 20.4501C14.7418 20.6168 15.1918 20.4668 15.4002 20.1085L16.6002 18.0835L18.9002 17.5585C19.3085 17.4668 19.5835 17.0835 19.5418 16.6668L19.3252 14.3168L20.8752 12.5418C21.011 12.3929 21.087 12.1991 21.0885 11.9976C21.0901 11.796 21.0171 11.601 20.8835 11.4501ZM10.7252 14.3585L8.9585 12.5918C8.88134 12.5146 8.82015 12.423 8.77839 12.3222C8.73664 12.2214 8.71515 12.1134 8.71515 12.0043C8.71515 11.8952 8.73664 11.7871 8.77839 11.6863C8.82015 11.5855 8.88134 11.4939 8.9585 11.4168C9.03565 11.3396 9.12724 11.2784 9.22804 11.2367C9.32885 11.1949 9.43689 11.1734 9.546 11.1734C9.65511 11.1734 9.76315 11.1949 9.86395 11.2367C9.96475 11.2784 10.0563 11.3396 10.1335 11.4168L11.3085 12.5918L14.2585 9.64179C14.3356 9.56464 14.4272 9.50344 14.528 9.46168C14.6288 9.41993 14.7369 9.39844 14.846 9.39844C14.9551 9.39844 15.0631 9.41993 15.1639 9.46168C15.2648 9.50344 15.3563 9.56464 15.4335 9.64179C15.5106 9.71894 15.5718 9.81053 15.6136 9.91133C15.6554 10.0121 15.6768 10.1202 15.6768 10.2293C15.6768 10.3384 15.6554 10.4464 15.6136 10.5472C15.5718 10.648 15.5106 10.7396 15.4335 10.8168L11.9002 14.3501C11.5835 14.6835 11.0502 14.6835 10.7252 14.3585Z"
      fill="#9CA8BB"
    />
  </svg>
);


export default SidebarAccount;
